import { render } from "./SelectState.vue?vue&type=template&id=0cbb0b1e&scoped=true&bindings={\"modelValue\":\"props\",\"placeholder\":\"props\",\"abbreviation\":\"props\",\"includeBlank\":\"props\",\"name\":\"props\",\"label\":\"props\",\"opts\":\"setup\",\"emit\":\"setup\"}"
import script from "./SelectState.vue?vue&type=script&lang=js"
export * from "./SelectState.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0cbb0b1e"

export default script